// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__37iY1","wrapper":"styles_wrapper__o4CPX","imageContainer":"styles_imageContainer__6Qa58","icon":"styles_icon__1NJEc","link":"styles_link__2LM_j"};